<template>
  <b-overlay :show="loading" class="animated">
    <v-server-table
      id="prep-workflow-server-table"
      :ref="ref"
      :columns="table_config.columns"
      :options="table_config.options"
      :theme="theme"
      class="w-100"
    >

      <span slot="name" slot-scope="{row}">
        <b-link :to="`/${route_root}/${row.id}`">
          {{ row.name }}
        </b-link>
      </span>

    </v-server-table>
  </b-overlay>
</template>

<script>
import BaseServerTable from '@/components/shared/BaseServerTable'
import SampleTypeCollection from '@/collections/lab/SampleTypeCollection'
import { AccessControlCheck } from '@/auth/AccessControlCheck'
import { PrepWorkflowRoutes } from '@/router/lab/PrepWorkflowRoutes'

export default {
  name: 'WorkflowPrepServerTable',
  extends: BaseServerTable,
  props: {
    collection: {
      type: Object,
      default: () => new SampleTypeCollection()
    },
    show_columns: {
      type: Array,
      default: () => [
        'name',
        // 'processes',
        // 'tasks',
      ]
    }
  },
  data () {
    return {
      table_config: Object.assign(this.getDefaultTableConfig(), {
        options: {
          headings: {
            name: 'Name'
          }
        }
      })
    }
  },
  computed: {
    route_root () {
      return PrepWorkflowRoutes.fetchRoot()
    }
  },
  methods: {
    checkPermission (permission) {
      return AccessControlCheck.checkPermission(permission)
    }
  }
}
</script>
